/* Second Set v3.19 · The sweatbands. Settings: Theme settings → Cart → Add-on (snippets/ss-cart-addon-cfg writes
   window.SS_ADDON). One product, one price ($9.90, its own page in the Shop). The half price with a strap is an
   automatic discount in Shopify (Discounts → "Sweatbands half price with your strap": buy any strap or pack, get one
   pair at 50%, once per strap or pack), so the bag and the checkout always agree.
   In the bag they work like the spare strap: a card in "Players also add" (snippets/ss-cart-upsell-card) with
   "+ price", then a normal line (colour swatches, quantity, Remove). This file only adds:
   1. Pre-checked: a strap in the bag (Cart → Free program → Products that unlock it) and no sweatbands yet →
      one pair goes in on its own, in the strap's colour (Mixed: the first colour of its "Colours" line).
      Cart attribute _addon_auto = 1 remembers it was added on its own.
   2. The strap leaves the bag → the pair added on its own leaves too (one pair less). Pairs the customer added
      themselves stay, at the shop price.
   3. Removed by the customer (Remove, or the quantity down to 0) → one request that takes them out and remembers
      it for this bag (cart attribute _addon_off = 1), so they are not added back. "+ price" on their card → one
      request that adds them and clears it.
   4. One pair per strap or pack gets the discount: with more pairs, Shopify splits them into two lines of the same
      colour. snippets/ss-cart-line shows them as one line (data-addon-keys lists both): its −/+, Remove and colour
      swatches change both lines in one request (total on the first line, 0 on the others; Shopify splits again).
   It runs inside the theme's free-program check (SS.gift.sync): after every add, every quantity change and on
   page load, and after a Moon Bundle add on the product page. */
(function () {
  'use strict';
  var A = window.SS_ADDON;
  if (!A || !A.product) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var URL_CART = root + 'cart.js';
  var URL_UPDATE = root + 'cart/update.js';
  var names = (A.colourNames || []).map(function (n) { return String(n).trim(); });
  var triggers = A.triggers || [];
  var ids = Object.keys(A.variants || {}).map(function (k) { return String(A.variants[k]); });
  var removed = false; // the customer took them out during this visit
  var busy = false;

  function firstOf(map) {
    var k = Object.keys(map || {})[0];
    return k ? map[k] : 0;
  }

  // A line's colour, lower case (a Mixed strap: the first colour of its "Colours" line)
  function colourOf(item) {
    var c = '';
    (item.options_with_values || []).forEach(function (o) {
      if (names.indexOf(String(o.name).toLowerCase()) > -1) c = String(o.value).toLowerCase();
    });
    if (c === 'mixed') {
      c = '';
      var props = item.properties || {};
      Object.keys(props).some(function (k) {
        var m = String(props[k] || '').match(/\d+\s*×\s*([^,]+)/);
        if (m) { c = m[1].trim().toLowerCase(); return true; }
        return false;
      });
    }
    return c;
  }

  // What the bag needs, as a /cart/update.js body, or null
  function plan(cart) {
    var items = (cart && cart.items) || [];
    var attrs = (cart && cart.attributes) || {};
    var strap = items.filter(function (i) { return triggers.indexOf(i.product_id) > -1; })[0];
    var mine = items.filter(function (i) { return i.product_id === A.product; });
    var auto = String(attrs._addon_auto || '') === '1';
    var off = removed || String(attrs._addon_off || '') === '1';
    var updates = {};

    if (strap) {
      // 1. Pre-checked
      if (mine.length || !A.auto || off) return null;
      var vid = A.variants[colourOf(strap)] || firstOf(A.variants);
      if (!vid) return null;
      updates[vid] = 1;
      return { updates: updates, attributes: { _addon_auto: '1' } };
    }

    // 2. No strap: the pair added on its own leaves
    if (!auto) return null;
    if (mine.length) {
      var line = mine[0];
      updates[line.key] = Math.max(0, line.quantity - 1);
    }
    return { updates: updates, attributes: { _addon_auto: '' } };
  }

  function send(body) {
    body.sections = window.SS.cart.sectionIds().join(',');
    body.sections_url = window.location.pathname;
    return window.SS.cart.request(URL_UPDATE, body);
  }

  function getCart() {
    return fetch(URL_CART, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // 1 and 2: chained to the free-program check, always on the bag as it is now
  function install() {
    var SS = window.SS;
    if (!SS || !SS.gift || !SS.cart) return false;
    if (SS.gift._addon) return true;
    var orig = SS.gift.sync;
    SS.gift.sync = function (cart) {
      return orig.call(SS.gift, cart).then(function (g) {
        return getCart().then(function (c) {
          var p = plan(c);
          return p ? send(p) : g;
        }).catch(function () { return g; });
      });
    };
    SS.gift._addon = true;
    return true;
  }
  if (!install()) document.addEventListener('DOMContentLoaded', install);

  function apply(data) {
    if (!data) return;
    if (data.sections) window.SS.cart.render(data.sections);
    if (typeof data.item_count === 'number') window.SS.cart.setCount(data.item_count);
  }

  function run(t, body, line) {
    if (busy) return;
    busy = true;
    if (line) line.style.opacity = '.45';
    t.disabled = true;
    Promise.resolve(typeof body === 'function' ? body() : body).then(send).then(apply).catch(function (err) {
      if (line) line.style.opacity = '';
      t.disabled = false;
      if (window.SS.toast) window.SS.toast(err.message);
    }).then(function () { busy = false; });
  }

  // 3 and 4. Before the theme handles the click (capture phase), in one request each
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-line-remove], [data-line-qty], [data-line-colour], [data-add-variant]');
    if (!t || !window.SS || !window.SS.cart) return;
    var body = null;
    if (t.hasAttribute('data-add-variant')) {
      var id = String(t.getAttribute('data-add-variant'));
      if (ids.indexOf(id) === -1 || !t.closest('[data-upsell]')) return;
      var up = {};
      up[id] = 1;
      body = { updates: up, attributes: { _addon_off: '', _addon_auto: '' } };
      removed = false;
    } else {
      var key = String(t.getAttribute('data-key') || '');
      if (ids.indexOf(key.split(':')[0]) === -1) return;
      var keys = String(t.getAttribute('data-addon-keys') || key).split(',').filter(Boolean);
      var all = {};
      keys.forEach(function (k) { all[k] = 0; });
      if (t.hasAttribute('data-line-remove') || t.getAttribute('data-line-qty') === '0') {
        // 3. Out of the bag, all lines of that colour
        body = { updates: all, attributes: { _addon_off: '1', _addon_auto: '' } };
        removed = true;
      } else if (keys.length < 2) {
        return; // a single line: the theme's own handler (quantity, assets/ss-v38.js for the colour)
      } else if (t.hasAttribute('data-line-qty')) {
        // 4. New total on the first line
        all[keys[0]] = parseInt(t.getAttribute('data-line-qty'), 10) || 0;
        body = { updates: all };
      } else {
        // 4. Other colour: both lines out, the same total in the new colour (added to that colour's own pairs)
        if (t.classList.contains('is-active')) return;
        var vid = String(t.getAttribute('data-line-colour'));
        var qty = parseInt(t.getAttribute('data-qty'), 10) || 1;
        body = function () {
          return getCart().then(function (c) {
            var have = 0;
            (c.items || []).forEach(function (i) { if (String(i.variant_id) === vid) have += i.quantity; });
            all[vid] = have + qty;
            return { updates: all };
          });
        };
      }
    }
    e.preventDefault();
    e.stopPropagation();
    run(t, body, t.closest('[data-line], [data-upsell]'));
  }, true);

  // Moon Bundle adds its packs with its own fetch('/cart/add.js'): run the same check once it has landed
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var p = nativeFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/cart/add') > -1 && init && typeof init.body === 'string' && init.body.indexOf('__moonbundle') > -1) {
        p.then(function (res) {
          if (!res.ok || !window.SS || !window.SS.gift) return;
          setTimeout(function () { window.SS.gift.sync().then(apply).catch(function () {}); }, 700);
        }).catch(function () {});
      }
    } catch (e) { /* leave the request as it is */ }
    return p;
  };
})();
